<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 mx-auto"
      >
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Reset Password
          </b-card-title>

          <!-- form -->
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="resetPassword"
            @keydown="form.onKeydown($event)"
          >
            

            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="new-password">New Password</label>
              </div>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="new-password"
                  v-model="form.new_password"
                  class="form-control-merge"
                  :type="newPasswordVisible ? 'text' : 'password'"
                  name="new-password"
                  placeholder="············"
                  :class="{
                    'is-invalid border-danger': form.errors.has('new_password'),
                  }"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="newPasswordVisible ? 'EyeOffIcon' : 'EyeIcon'"
                    @click="togglePasswordVisibility('new_password')"
                  />
                </b-input-group-append>
              </b-input-group>
              <has-error :form="form" field="new_password"></has-error>
            </b-form-group>
          
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="confirm-password">Confirm Password</label>
              </div>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="confirm-password"
                  v-model="form.password_confirmation"
                  class="form-control-merge"
                  :type="confirmPasswordVisible ? 'text' : 'password'"
                  name="password_confirmation"
                  placeholder="············"
                  :class="{
                    'is-invalid border-danger':
                      form.errors.has('password_confirmation'),
                  }"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="confirmPasswordVisible ? 'EyeOffIcon' : 'EyeIcon'"
                    @click="togglePasswordVisibility('password_confirmation')"
                  />
                </b-input-group-append>
              </b-input-group>
              <has-error :form="form" field="password_confirmation"></has-error>
            </b-form-group>
            <!-- submit buttons -->
            <b-button
              type="submit"
              variant="danger"
              block
              :disabled="form.busy"
            >
              Reset Password
            </b-button>
          </b-form>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";

import { HasError, AlertError } from "vform/src/components/bootstrap5";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    HasError,
    AlertError,
  },
  data() {
    return {
      form: new Form({
        new_password: null,
        password_confirmation: null,
        token: this.$route.params.token
      }),
      newPasswordVisible: false,
      confirmPasswordVisible: false,
    };
  },

  methods: {
    resetPassword() {
      this.form
        .post(`/candidate/reset-password/${this.$route.params.token}`, this.form)
        .then((res) => {
          if (res.data) {
            this.s(res.data.message);
            this.$router.push({
              name: "login",
            });
          }
        })
        .catch((e) => {
          this.e(e.response.data.error);
        });
    },

    togglePasswordVisibility(field) {
      if (field == "old_password") {
        this.oldPasswordVisible = !this.oldPasswordVisible;
      } else if (field == "new_password") {
        this.newPasswordVisible = !this.newPasswordVisible;
      } else if (field == "password_confirmation") {
        this.confirmPasswordVisible = !this.confirmPasswordVisible;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
